export const navigation = [
  // {
  //   name: "Dashboard",
  //   url: "/dashboard",
  //   icon: "th-large",
  // },
  {
    name: "Welcome",
    url: "/welcome",
    icon: "home",
    id: "welcome",
  },
  {
    name: 'Candidates',
    url: '/candidates',
    icon: 'address-book',
  },
  {
    name: "Recruiting",
    url: "/recruiting",
    icon: "briefcase",
  },
  // webinar
  {
    name: "Experiences",
    url: "/experiences",
    icon: "play-circle",
  },
  {
    name: "Events",
    url: "/events",
    icon: "calendar",
  },
  {
    name: "Articles",
    url: "/articles",
    icon: "list-alt",
  },
  {
    name: "Polls",
    url: "/polls",
    icon: "tachometer-alt",
  },
  // {
  //   name: 'Chat',
  //   url: '/chat',
  //   icon: 'comments',
  //   hasBadge: true
  // },
  {
    name: "Profile",
    url: "/profile",
    icon: "user",
  },
  {
    name: "Reports",
    url: "/reports",
    icon: "table",
  },
  {
    name: "Data Loop",
    url: "/dataloop",
    icon: "chart-pie",
    id: "dataloop",
  },
  {
    name: "Digital Career Days",
    url: "/career_days",
    icon: "landmark",
  },
  {
    name: "Change Password",
    id: "change-password",
    url: "/change-password",
    icon: "sign-out-alt",
  },
  {
    name: "Logout",
    url: "/login",
    icon: "sign-out-alt",
  },
  {
    name: "Feedback (beta)",
    id: "feedback",
    url: "/feedback",
    icon: "comment-alt",
  },
];
